/**
 * @nubeteck/formeck (0.19.5)
 * Copyright (c) Nubeteck, SRL.
 */
import { j as e } from "../../chunks/jsx-runtime.BwWtxLpl.js";
import { Button as u } from "@nubeteck/components";
import { F as b, b as a, e as l } from "../../chunks/index.esm.eyITaPoj.js";
import S from "../form/form.js";
import j, { useFormeckConfig as p } from "../../contexts/formeck-config/formeck-config.js";
import "../../contexts/stepper/stepper.js";
const d = ({
  methods: r,
  children: t,
  formProps: o,
  initialConfig: i,
  withInternalForm: s = !0
}) => /* @__PURE__ */ e.jsx(b, { ...r, children: /* @__PURE__ */ e.jsx(j, { configs: i, children: s ? /* @__PURE__ */ e.jsx(S, { ...o, children: t }) : t }) });
d.SubmitButton = function(t) {
  const { inputSize: o } = p(), { isDirty: i, isValid: s, submitCount: n, isSubmitting: m } = a();
  return /* @__PURE__ */ e.jsx(
    u,
    {
      type: "primary",
      size: o,
      loading: m,
      disabled: !s && (i || n > 0),
      ...t
    }
  );
};
d.ResetButton = function({
  onClick: t,
  children: o,
  resetOptions: i,
  ...s
}) {
  const { reset: n } = l(), { inputSize: m } = p(), { isDirty: c, isSubmitting: f } = a();
  return /* @__PURE__ */ e.jsx(
    u,
    {
      type: "dashed",
      size: m,
      disabled: !c,
      loading: f,
      onClick: (x) => {
        n(i?.values, i?.keepStateOptions), t && t(x);
      },
      ...s,
      children: o
    }
  );
};
export {
  d as default
};
